import { Injectable } from "@angular/core";
import { Action, State, StateContext, Store } from "@ngxs/store";
import { LanguageStateActions } from "./language.actions";

export interface LanguageStateModel {
    currentLanguage: string;
}

@Injectable()
@State<LanguageStateModel>({
    name: "language",
    defaults: {
        currentLanguage: "sv",
    },
})
export class LanguageState {
    constructor(private store: Store) {}

    @Action(LanguageStateActions.SetLanguage)
    public setLanguage(ctx: StateContext<LanguageStateModel>, action: LanguageStateActions.SetLanguage): void {
        ctx.patchState({
            currentLanguage: action.language,
        });
    }
}
